import { frame } from "motion";
import { MotionValue, useSpring } from "motion/react";
import { RefObject, useEffect } from "react";

const spring = { damping: 20, stiffness: 300, restDelta: 0.001 };

export function useFollowPointer(ref: RefObject<HTMLElement | null>): {
  x: MotionValue<number>;
  y: MotionValue<number>;
} {
  const transformX = useSpring(0, spring);
  const transformY = useSpring(0, spring);

  useEffect(() => {
    if (!ref.current) return;

    const handlePointerMove = ({ clientX, clientY }: PointerEvent) => {
      // only update the motion values once per frame, reducing unnecessary work
      frame.read(() => {
        if (!ref.current) return;

        const element = ref.current;

        const prevTransformX = transformX.get();
        const prevTransformY = transformY.get();

        const rect = element.getBoundingClientRect();
        const dx = clientX - rect.left - rect.width / 2;
        const dy = clientY - rect.top - rect.height / 2;

        transformX.set(prevTransformX + dx);
        transformY.set(prevTransformY + dy);
      });
    };

    window.addEventListener("pointermove", handlePointerMove);

    return () => window.removeEventListener("pointermove", handlePointerMove);
  }, [ref]);

  return { x: transformX, y: transformY };
}
